/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_appsync_graphqlEndpoint": "https://gvedruwf7fadfpn2ven3qyy2jm.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-3jypr7e4wfc6fibx3xl23cnwoi",
    "aws_cloud_logic_custom": [
        {
            "name": "offerings",
            "endpoint": "https://9uy8wbwyv4.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        },
        {
            "name": "onboarding",
            "endpoint": "https://oezmlinbe8.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:c0304376-dc2f-4f9c-b57d-ea42aa70c80b",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_zDIySHDpV",
    "aws_user_pools_web_client_id": "481e1a4lcknml7hrf5rvutrkkl",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "dunkirk224856-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
